/* Auth */

/* DEBUG */
export const LOAD_DEBUG_STATE = "LOAD_DEBUG_STATE";

/* GENERAL */
export const TOGGLE_MUSIC = "TOGGLE_MUSIC";
export const RESET_STORE = "RESET_STORE";
export const SET_WS_CONNECTION = "SET_WS_CONNECTION";

/* USERS */
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const UPDATE_CURRENT_USER = "UPDATE_CURRENT_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_LAST_USER = "LOGOUT_USER_LAST_USER";
export const LOGIN_USER = "LOGIN_USER";
export const SET_LOGGED_IN = "SET_LOGGED_IN";
export const NEW_USER_RESET = "NEW_USER_RESET";

/*** LOADING ***/
export const SET_LOADING = "SET_LOADING";

/*** QUIZ ***/
export const GET_QUIZ_SUCCESS = "GET_QUIZ_SUCCESS";
export const SYNC_QUIZ_SUCCESS = "SYNC_QUIZ_SUCCESS";
export const SET_QUIZ_ACTIVE = "SET_QUIZ_ACTIVE";
export const SET_QUIZ = "SET_QUIZ";
export const QUIZ_NEXT_PAGE = "QUIZ_NEXT_PAGE";
export const QUIZ_PREV_PAGE = "QUIZ_PREV_PAGE";
export const SET_PROGRESS = "SET_PROGRESS";
export const UPDATE_PROGRESS = "UPDATE_PROGRESS";
export const LOAD_QUIZ = "LOAD_QUIZ";
export const RESULTS_SUBMITTED_SUCCESS = "RESULTS_SUBMITTED_SUCCESS";
export const RESULTS_SUBMITTED_FAILED = "RESULTS_SUBMITTED_FAILED";
export const RESET_QUIZ_DATA = "RESET_QUIZ_DATA";
export const SET_PRIZES = "SET_PRIZES";

/*** TEAMS ***/
export const SET_ALL_TEAMS = "SET_ALL_TEAMS";
export const ADD_TEAM_SUCCESS = "ADD_TEAM_SUCCESS";
export const LOAD_TEST_TEAM_DATA_SUCCESS = "LOAD_TEST_TEAM_DATA_SUCCESS";
export const REMOVE_TEAM_SUCCESS = "REMOVE_TEAM_SUCCESS";
export const UPDATE_TEAM_SUCCESS = "UPDATE_TEAM_SUCCESS";
export const REGISTER_TEAM_SUCCESS = "REGISTER_TEAM_SUCCESS";
export const CLEAR_TEAMS_SUCCESS = "CLEAR_TEAMS_SUCCESS";
export const SET_TEAM_RESULTS_SUCCESS = "SET_TEAM_RESULTS_SUCCESS";
export const SET_TEAM_CW_RESULTS_SUCCESS = "SET_TEAM_CW_RESULTS_SUCCESS";
export const SET_TEAM_BREAKER_ANSWER_SUCCESS =
  "SET_TEAM_BREAKER_ANSWER_SUCCESS";
export const SET_BREAKER_RESULTS_SUCCESS = "SET_BREAKER_RESULTS_SUCCESS";
export const SUBMIT_SCORES_SUCCESS = "SUBMIT_SCORES_SUCCESS";
export const TEAM_SCORES_UPDATED = "TEAM_SCORES_UPDATED";

/*** CHROMECAST */
export const CC_CONNECTED = "CC_CONNECTED";
export const CC_DISCONNECTED = "CC_DISCONNECTED";

export const SET_PARAMS = "SET_PARAMS";
